module.exports = __webpack_public_path__ + "static/img/pdf-64px.55bcad13.png";